import { DetailFieldList } from "@/shared/components";
import { DetailSection } from "../../../detail-section";
import type { PropulsaoSectionViewModel } from "./types-propulsao-section";

export function PropulsaoSectionView({
  id,
  title,
  testId,
  fieldsTestId,
  status,
  errorMessage,
  loadingMessage,
  emptyContent,
  onReauthenticate,
  onRetry,
  ultimaAtualizacao,
  fields,
}: PropulsaoSectionViewModel) {
  return (
    <DetailSection
      id={id}
      title={title}
      ultimaAtualizacao={ultimaAtualizacao}
      testId={testId}
      status={status}
      loadingMessage={loadingMessage}
      errorMessage={errorMessage}
      emptyContent={emptyContent}
      onReauthenticate={onReauthenticate}
      onRetry={onRetry}
    >
      <DetailFieldList testId={fieldsTestId} fields={fields} />
    </DetailSection>
  );
}
